module.exports = __webpack_public_path__ + "static/media/BloodStain.d426a7e6.glb";